import { useCallback, useContext } from "react";
import { clickNoFeeWeekendPopup, impressionNoFeeWeekendPopup } from "@cart-client/analytics/events/NoWeekendPopup";
import { AnalyticsContext } from "@swiggy-private/checkout-core";

export const useNoFeeWeekendAnalytics = () => {
    const { impressionEvent, clickEvent } = useContext(AnalyticsContext);

    const onImpressionNoFeeWeekendPopup = useCallback(
        (cartId?: string, originalCartId?: string) => {
            impressionNoFeeWeekendPopup(impressionEvent, {
                cartId: cartId || "",
                originalCartId: originalCartId || "",
            });
        },
        [impressionEvent],
    );

    const onClickNoFeeWeekendPopup = useCallback(
        (cartId: string, originalCartId: string, clickAction: string) => {
            clickNoFeeWeekendPopup(clickEvent, { cartId, originalCartId, clickAction });
        },
        [clickEvent],
    );

    return {
        onImpressionNoFeeWeekendPopup,
        onClickNoFeeWeekendPopup,
    };
};
